import React, {Component} from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import withStyles from '@material-ui/core/styles/withStyles';
import ListItem from '@material-ui/core/ListItem';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import IconExit from '@material-ui/icons/ExitToApp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import logo from '../../../assets/proserint_logo2.png';
import {styles} from './styles';


export class CustomDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      link: '',
      role: '',
      anchorEl: null,
      open: false
    };
    this.handleCloseSession = this.handleCloseSession.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.handleGoDocuments = this.handleGoDocuments.bind(this);
    this.handleGoProfile = this.handleGoProfile.bind(this);
    this.handleGoAccountants = this.handleGoAccountants.bind(this);
    this.handleGoCustomers = this.handleGoCustomers.bind(this);
    this.handleGoChecklist = this.handleGoChecklist.bind(this);
    this.handleGoDashboard = this.handleGoDashboard.bind(this);
    this.renderDrawer = this.renderDrawer.bind(this);
  }

  async componentWillMount() {
    await sessionStorage.getItem('role');
    this.setState({role: sessionStorage.getItem('role')});

    if (this.state.role.includes('administrador')) {
      this.setState({link: 'Usuarios'});
    } else {
      if (this.state.role.includes('contador')) {
        this.setState({link: 'Clientes'});
      }
      if (this.state.role.includes('cliente')) {
        this.setState({link: 'Dashboard'});
      }
    }
  }

  handleMenu = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleClose = () => {
    this.setState({anchorEl: null});
  };

  // eslint-disable-next-line class-methods-use-this
  async handleCloseSession() {
    await sessionStorage.setItem('token', '');
    document.location.reload();
  }

  handleDrawerToggle = () => {
    this.setState(state => ({mobileOpen: !state.mobileOpen}));
  };

  handleGoDocuments() {
    this.setState({link: 'Documentos'});
    this.props.handleGoDocuments();
  }
  handleGoChecklist() {
    this.setState({link: 'Checklist'});
    this.props.handleGoChecklist();
  }
  handleGoDashboard() {
    this.setState({link: 'Dashboard'});
    this.props.handleGoDashboard();
  }

  handleGoProfile() {
    this.setState({link: 'Perfil'});
    this.props.handleGoProfile();
  }

  handleGoAccountants() {
    this.setState({link: 'Usuarios'});
    this.props.handleGoAccountants();
  }

  handleGoCustomers() {
    this.setState({link: 'Clientes'});
    this.props.handleGoCustomers();
  }

  // eslint-disable-next-line class-methods-use-this
  renderDrawer() {
    const {classes, isAdmin, isAccountant, isCustomer, accountant, email, password} = this.props;
    const {link} = this.state;
    const accountantDrawer = (
      <List >
        <Link to="/inicio" className={classes.link} href="null">
          <ListItem button className={classes.sections} >
            <Typography variant="subtitle1" className={link === 'Clientes' ? classes.linkTextSelected : classes.linkText} noWrap>
                Clientes
            </Typography>
          </ListItem>
        </Link>
      </List>
    );
    const adminDrawer = (
      <List >
        <Link to="/inicio" className={classes.link} href="null">
          <ListItem button className={classes.sections} onClick={this.handleGoAccountants}>
            <Typography variant="subtitle1" className={link === 'Usuarios' ? classes.linkTextSelected : classes.linkText}>
                Usuarios
            </Typography>
          </ListItem>
        </Link>
        <Link to="/inicio" className={classes.link} href="null">
          <ListItem button className={classes.sections} onClick={this.handleGoCustomers}>
            <Typography variant="subtitle1" className={link === 'Clientes' ? classes.linkTextSelected : classes.linkText} >
                Clientes
            </Typography>
          </ListItem>
        </Link>
      </List>
    );
    const customerDrawer = (
      <List >
        <ListItem button className={classes.sectionss} onClick={this.handleGoDashboard}>
          <Typography variant="subtitle1" className={link === 'Dashboard' ? classes.linkTextSelected : classes.linkText} noWrap>
            Dashboard
          </Typography>
        </ListItem>

        <ListItem button className={classes.sectionss} onClick={this.handleGoChecklist}>
          <Typography variant="subtitle1" className={link === 'Checklist' ? classes.linkTextSelected : classes.linkText} noWrap>
            Checklist
          </Typography>
        </ListItem>

        <ListItem button className={classes.sectionss} onClick={this.handleGoDocuments}>
          <Typography variant="subtitle1" className={link === 'Documentos' ? classes.linkTextSelected : classes.linkText} noWrap>
            Comprobantes
          </Typography>
        </ListItem>

        <ListItem button className={classes.sectionss} onClick={this.handleGoProfile}>
          <Typography variant="subtitle1" className={link === 'Perfil' ? classes.linkTextSelected : classes.linkText} noWrap>
            Perfil
          </Typography>
        </ListItem>

        <ListItem className={classes.wrapDivider} >
          <Divider className={classes.divider} />
        </ListItem>

        <ListItem className={classes.information}>
          <Typography variant="subtitle2" color="primary" noWrap>
              Proserint
          </Typography>
        </ListItem>
        <ListItem className={classes.information}>
          <Avatar src={accountant.image} className={classes.avatar} />
        </ListItem>
        <ListItem className={classes.information}>
          <Typography variant="body1" noWrap>
            {accountant.name}
          </Typography>
        </ListItem>
        <ListItem className={classes.information}>
          <Typography variant="caption" color="secondary" noWrap>
            {accountant.email}
          </Typography>
        </ListItem>
        <ListItem className={classes.information}>
          <Typography variant="caption" color="secondary" noWrap>
            {accountant.cellPhone}
          </Typography>
        </ListItem>
      </List>
    );

    if (isAdmin) {
      return adminDrawer;
    }

    if (isAccountant) {
      return accountantDrawer;
    }

    if (isCustomer) {
      return customerDrawer;
    }

    return '';
  }

  render() {
    const {classes} = this.props;
    const {anchorEl} = this.state;
    const open = Boolean(anchorEl);
    return (
      <div>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar className={classes.toolbarWrapper}>
            <IconButton
              color="primary"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.grow} />
            <Typography variant="subtitle1" color="secondary" noWrap>
              {this.props.name}
            </Typography>
            <IconButton
              buttonRef={(node) => {
                this.anchorEl = node;
              }}
              onClick={this.handleMenu}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              open={open}
              onClose={this.handleClose}
            >
              <MenuItem onClick={this.handleCloseSession}> <IconExit /> Cerrar sesión</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        <nav className={classes.drawer}>
          <Hidden smUp implementation="css">
            <Drawer
              variant="temporary"
              anchor="left"
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper
              }}
            >
              <div className={classes.toolbar}>
                <div style={{display: "flex", height:"100%", justifyContent: "center", alignItems: "center"}}>
                  <img src={logo} alt="logo" className={classes.logo} />
                </div>
                
              </div>
              {this.renderDrawer()}
            </Drawer>
          </Hidden>
          <Hidden smDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper
              }}
              variant="permanent"
              open
            >
              <div className={classes.toolbar}>
                <div style={{display: "flex", height:"100%", justifyContent: "center", alignItems: "center"}}>
                  <img src={logo} alt="logo" className={classes.logo} />
                </div>
              </div>

              {this.renderDrawer()}
            </Drawer>
          </Hidden>
        </nav>
      </div>
    );
  }
}

CustomDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  accountant: PropTypes.object,
  isAdmin: PropTypes.bool.isRequired,
  isAccountant: PropTypes.bool.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleGoDocuments: PropTypes.func.isRequired,
  handleLoginDora: PropTypes.func.isRequired,
  handleGoProfile: PropTypes.func.isRequired,
  handleGoAccountants: PropTypes.func.isRequired,
  handleGoCustomers: PropTypes.func.isRequired
};


export default (withStyles(styles)(CustomDrawer));

